const { __ } = wp.i18n;

export function SearchForm({ searchQuery, setSearchQuery, onSubmit, onResetQuery, showReset }) {
  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  return (
    <form onSubmit={onSubmit} className="table-comercios--search-form content-form content-form--table-comercios">
      <div className="field field-search d-flex gap-1 w-550">
        <input
          type="text"
          name="search"
          className="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder={__("Introduce el nombre del comercio", "bizum-website")} />
        <button type="submit" className="wp-button has-icon has-icon-after icon-search has-button-blue-600-background-color">
          <span className="cta-icon">
            <span className="icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M2 9.5C2 13.6421 5.35786 17 9.5 17C11.2316 17 12.8262 16.4131 14.0957 15.4275C14.1435 15.5286 14.2092 15.6234 14.2929 15.7071L20.2929 21.7071C20.6834 22.0976 21.3166 22.0976 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L15.7071 14.2929C15.6234 14.2092 15.5286 14.1435 15.4275 14.0957C16.4131 12.8262 17 11.2316 17 9.5C17 5.35786 13.6421 2 9.5 2C5.35786 2 2 5.35786 2 9.5ZM4 9.5C4 6.46243 6.46243 4 9.5 4C12.5376 4 15 6.46243 15 9.5C15 12.5376 12.5376 15 9.5 15C6.46243 15 4 12.5376 4 9.5Z" fill="#202020" />
              </svg>
            </span>
          </span>
          <span className="cta-title">
            {__('Buscar', 'bizum-website')}
          </span>
        </button>
        { showReset && (<a href="#" className="input-reset has-text-gray-500-color has-xs-font-size" onClick={onResetQuery}>
          { __('Reset', 'bizum-website') }
        </a>) }
      </div>
    </form>
  )
}